<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Create New User
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          v-model="username"
          class="pb-20"
          label="username"
          placeholder="username"
          single-line
          @input="setCreateDisabled"
        >
        </v-text-field>
        <v-text-field
          v-model="password"
          class="pb-20"
          label="password"
          single-line
          @input="setCreateDisabled"
        >
        </v-text-field>
        <v-text-field
          v-model="email"
          class="pb-20"
          label="email"
          single-line
          @input="setCreateDisabled"
        >
        </v-text-field>
        <v-select
          v-model="role"
          :items="roleSelection"
          class="pb-20"
          label="role"
          @input="setCreateDisabled"
        >
        </v-select>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="light-green" @click="onCreateClick()" :disabled="createDisabled">Create</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
  },

  data() {
    return {
      //yesNo: ['Yes', 'No'],
      roleSelection: ['admin', 'engineer', 'support_lvl2', 'support', 'tech', 'ezadas', 'guest'],
      createDisabled: true,
      username: '',
      password: '',
      email: '',
      role: '',
    };
  },

  methods: {
    setCreateDisabled() {
      this.createDisabled = !(
        this.username.length > 0
        && this.password.length > 0
        && this.email.length > 0
        && this.role.length > 0
      );
    },

    onCancelClick() {
      this.creatDisabled = true;
      this.username = '';
      this.password = '';
      this.email = '';
      this.role = '';
      this.$emit('close', null);
    },

    onCreateClick() {
      this.creatDisabled = true;
      this.$emit('close', {
        username: this.username, password: this.password, email: this.email, role: this.role, active: true,
      });
      this.username = '';
      this.password = '';
      this.email = '';
      this.role = '';
    },
  },
};
</script>
